import React, { FC } from 'react';
import { useDispatch } from 'react-redux';
import { CloseThin } from '~/components/Icons/fill';
import { trackEvent } from '~/helpers/tracking';
import { setPageLoading } from '~/redux/actions/common';
import { Modals, Product } from '~/types/products';
import { ConsumerLabelModalStyled } from './ConsumerLabelModalStyled';
import { BROADBAND_CONSUMER_LABEL_URL } from '~/constants/products';

const production = process.env.environment === 'production';
const environment = production ? 'production' : 'development';
const consumerLabelUrl = BROADBAND_CONSUMER_LABEL_URL[environment];

interface Props {
  selectedProduct: Product;
  setActiveModal: (key?: Modals) => void;
  visible: boolean;
  tracking?: {
    elementType?: string;
    location?: string;
    position?: string;
    text?: string;
  };
}

const BroadbandConsumerLabel: FC<Props> = ({ selectedProduct, setActiveModal, visible, tracking }) => {
  const dispatch = useDispatch();
  const handleCancel = () => {
    setActiveModal(undefined);
    dispatch(setPageLoading(false));
    trackEvent({
      action: 'elementClicked',
      data: {
        elementType: 'BUTTON',
        position: 'broadband_consumer_label_modal',
        action: 'CANCEL',
      },
    });
    return;
  };

  if (!visible) return null;

  trackEvent({
    action: 'elementViewed',
    data: {
      elementType: 'Broadband Consumer Label Modal',
      location: '/plan-package',
      position: 'broadband_consumer_label_modal',
      text: `Broadband Consumer Label Modal Viewed`,
      ...tracking,
    },
  });

  return (
    <ConsumerLabelModalStyled>
      <CloseThin onClick={handleCancel} data-testid="modal-btn-close" />
      <div className="consumer-label__modal">
        <iframe
          src={`${consumerLabelUrl}?labelid=${selectedProduct?.labelId}`}
          title="Frontier Broadband Consumer Label"
        />
      </div>
    </ConsumerLabelModalStyled>
  );
};

BroadbandConsumerLabel.displayName = 'BroadbandConsumerLabel';

export default BroadbandConsumerLabel;
